<form class="qualification-tab-form" style="margin-top: 20px;" [formGroup]="RequestCopyTab">
  <input type="hidden" formControlName="id">
  <div fxLayout="row" class="address-width">
    <div class="col-4">
      <div class="row">
        <mat-form-field style="max-width: 200px">
          <input type="number" min="1" formControlName="numberOfCopies"  matInput name="value" placeholder="Number of Copies">
        </mat-form-field>
      </div>
      <div class="row" style="font-style: italic">(fees apply per copy)
      </div>

    </div>
    <div class="col-1"><mat-label class="boldlabel" [ngClass]="sendToMode == null ? 'errorMsg' : ''">Send To:</mat-label>
    </div>
    <div class="col-6">
      <div fxLayout="row">
        <mat-checkbox [checked]="sendToMode === 1" (change)="onCheck(1, $event)" >Registrant Email Address on file
        </mat-checkbox>
      </div>
      <div fxLayout="row">
        <mat-checkbox [checked]="sendToMode === 2" (change)="onCheck(2, $event)" >Registrant Mailing Address on file
        </mat-checkbox>
      </div>
      <div fxLayout="row">
        <mat-checkbox [checked]="sendToMode === 3" (change)="onCheck(3, $event)" >Person listed below Email Address
        </mat-checkbox>
      </div>
      <div fxLayout="row">
        <mat-checkbox [checked]="sendToMode === 4" (change)="onCheck(4, $event)" >Person listed below Mailing Address
        </mat-checkbox>
      </div>
      <div class="invalid-feedback" *ngIf="RequestCopyTab.controls['sendToMode'].errors">At least one checkbox is required to check</div>
    </div>
  </div>
  <div fxLayout="row">
    <mat-form-field class="address-width">
      <mat-label class="boldlabel">To</mat-label>
      <input matInput placeholder="To" formControlName="sendToName" value="">
    </mat-form-field>
  </div>
  <div fxLayout="row">
    <mat-form-field class="address-width">
      <mat-label class="boldlabel">Address 1</mat-label>
      <input matInput placeholder="Address 1" formControlName="sendToAddressLine1" value="">
    </mat-form-field>
  </div>
  <div fxLayout="row">
    <mat-form-field class="address-width">
      <mat-label>Address 2</mat-label>
      <input matInput placeholder="Address 2" formControlName="sendToAddressLine2" value="">
    </mat-form-field>
  </div>
  <div fxLayout="row">
    <mat-form-field class="address-width">
      <mat-label>Attention</mat-label>
      <input matInput placeholder="Attention" formControlName="sendToAddressLine3" value="">
    </mat-form-field>
  </div>
  <div fxLayout="row" class="address-width">
    <div class="col-4">
      <mat-form-field>
        <mat-label class="boldlabel">City</mat-label>
        <input matInput placeholder="City" formControlName="sendToCity" value="">
      </mat-form-field>
    </div>
    <div class="col-1"></div>
    <div class="col-3">
      <mat-form-field>
        <mat-label class="boldlabel">State</mat-label>
        <mat-select formControlName="sendToState">
          <mat-option *ngFor="let rl of StateTypes" [value]="rl.abbrv">
            {{rl?.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-1"></div>
    <div class="col-3">
      <mat-form-field>
        <mat-label class="boldlabel">Zip</mat-label>
        <input matInput placeholder="Zip" mask="00000||00000-0000" formControlName="sendToZipCode" value="">
      </mat-form-field>
    </div>
  </div>
  <div fxLayout="row" class="address-width">
    <div class="col-4">
      <mat-form-field class="phone-width">
        <mat-label class="boldlabel">Phone</mat-label>
        <input matInput placeholder="(###) ###-####" mask='(000) 000-0000' formControlName="sendToPhoneNumber" value="">
      </mat-form-field>
    </div>
    <div class="col-1"></div>
    <div class="col-7">
      <mat-form-field class="email-width">
        <mat-label class="boldlabel">Email</mat-label>
        <input type="email" matInput placeholder="Email"
          formControlName="sendToEmailAddress" value="">
      </mat-form-field>
    </div>
  </div>
</form>
